exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-actions-renderer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  padding: 16px;\n  height: 64px;\n}\n.input-group-actions-renderer .is-default-checkbox {\n  margin: 3px -5px 0 0;\n}\n.input-group-actions-renderer .preview-input-group-button {\n  margin: 0;\n  padding: 1px 0 0 0;\n}\n.input-group-actions-renderer .delete-button,\n.input-group-actions-renderer .edit-button {\n  font-size: 19px;\n  padding: 3px 0;\n}\n", ""]);

// exports
